import { render, staticRenderFns } from "./UserEditChangePassword.vue?vue&type=template&id=2edb848a&"
import script from "./UserEditChangePassword.vue?vue&type=script&lang=js&"
export * from "./UserEditChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports